import { FunctionComponent } from "react";

export const SignalIdunaLogo: FunctionComponent = () => {
  return (
    <div className="flex justify-center items-center gap-2">
      <span className="mt-3 hidden md:inline">In Kooperation mit</span>
      <img
        src="/images/brand/signal-iduna.png"
        className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
        alt="SIGNAL IDUNA"
      />
    </div>
  );
};
